/**
 * @fileoverview Общие математические хелперы для симуляции и рендера.
 * Углы — в радианах, если не указано иное.
 */

/** Ограничить `v` включительным диапазоном `[a, b]`. */
export function clamp(v: number, a: number, b: number): number {
  return v < a ? a : v > b ? b : v;
}

/** Линейная интерполяция от `a` к `b` с фактором `t` (без clamp). */
export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

/** Равномерный случайный float в `[a, b)`. */
export function rnd(a: number, b: number): number {
  return a + Math.random() * (b - a);
}

/** Включительный случайный целый в `[a, b]`. */
export function rndi(a: number, b: number): number {
  return Math.floor(rnd(a, b + 1));
}

/**
 * Случайный элемент непустого массива.
 * @throws если `arr` пуст
 */
export function pick<T>(arr: readonly T[]): T {
  if (arr.length === 0) {
    throw new RangeError("pick() requires a non-empty array");
  }
  return arr[Math.floor(Math.random() * arr.length)]!;
}

/** Евклидово расстояние между точками `(x1, y1)` и `(x2, y2)`. */
export function dist(x1: number, y1: number, x2: number, y2: number): number {
  return Math.hypot(x1 - x2, y1 - y2);
}

/**
 * Кратчайшая угловая интерполяция от `from` к `to` с фактором `t`.
 * Стабильно ведет себя при переходе через ±π.
 */
export function angLerp(from: number, to: number, t: number): number {
  const twoPi = Math.PI * 2;
  let d = ((to - from + Math.PI) % twoPi + twoPi) % twoPi - Math.PI;
  return from + d * t;
}

/** Формат секунд как `m:ss` для часов HUD. */
export function fmtTime(t: number): string {
  const m = Math.floor(t / 60);
  const s = Math.floor(t % 60);
  return `${m}:${String(s).padStart(2, "0")}`;
}
